import axiosApiInstance from "../../app/axios";
import { API_BASE_URL } from "../../app/utils";

const staffUrl = `${API_BASE_URL}/user-store/v1/staff`;
const rolesUrl = `${API_BASE_URL}/user-store/v1/staff-roles`;

export const getStaff = ({ search, page, size }) =>
  axiosApiInstance.get(staffUrl, {
    params: { search: search || undefined, page, size },
  });

export const getStaffRoles = () => axiosApiInstance.get(rolesUrl);

export const createStaff = (request) => axiosApiInstance.post(staffUrl, request);

export const grantStaffRoles = (id, roles) =>
  axiosApiInstance.post(`${staffUrl}/${id}/roles`, { roles });

export const revokeStaffRole = (id, role) =>
  axiosApiInstance.delete(`${staffUrl}/${id}/roles/${encodeURIComponent(role)}`);

export const changeStaffPrimaryRole = (id, primaryRole) =>
  axiosApiInstance.put(`${staffUrl}/${id}/primary-role`, { primaryRole });

export const enableStaff = (id) => axiosApiInstance.post(`${staffUrl}/${id}/enable`, {});

export const disableStaff = (id) => axiosApiInstance.post(`${staffUrl}/${id}/disable`, {});

export const resetStaffPassword = (id) =>
  axiosApiInstance.post(`${staffUrl}/${id}/reset-password`, {});

export const getStaffAudit = ({ actor, target, actorType, action, page, size }) =>
  axiosApiInstance.get(`${staffUrl}/audit`, {
    params: {
      actor: actor || undefined,
      target: target || undefined,
      actorType: actorType || undefined,
      action: action || undefined,
      page,
      size,
    },
  });

export const getStaffAuditDiscrepancies = () =>
  axiosApiInstance.get(`${staffUrl}/audit/discrepancies`);
